import React from 'react';
import { useDispatch } from 'react-redux';
import { userActions } from '@/store/user';
import { Button as ANTDButton, TabsMenu } from '@/components';
import {
  SideBarConfigAdmin,
  SideBarConfigInvestor,
  SideBarConfigReferral,
  SideBarConfigSuperAdmin
} from '@/components/common/organisms/AppSideBar/config';
import { Col, Container, BREAKPOINTS } from '@/ui';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Drawer, Flex, Typography } from 'antd';
import { useLocation, useNavigate } from 'react-router';
import { MenuOutlined } from '@ant-design/icons';

export const AppSideBar = ({ userRole, menuVisible, openMenu, closeMenu, referralView }) => {
  const dispatch = useDispatch();

  const logout = () => {
    dispatch(userActions.logout());
  };

  return (
    <SideBarContainer>
      {userRole === 'investor' && (
        <InvestorList
          menuVisible={menuVisible}
          closeMenu={closeMenu}
          config={referralView ? SideBarConfigReferral : SideBarConfigInvestor}
          referralView={referralView}
        />
      )}

      {userRole === 'admin' && (
        <AdminList
          logout={logout}
          config={SideBarConfigAdmin}
          menuVisible={menuVisible}
          openMenu={openMenu}
          closeMenu={closeMenu}
        />
      )}

      {userRole === 'superAdmin' && (
        <AdminList
          logout={logout}
          config={SideBarConfigSuperAdmin}
          menuVisible={menuVisible}
          openMenu={openMenu}
          closeMenu={closeMenu}
        />
      )}
    </SideBarContainer>
  );
};

const InvestorList = ({ config, menuVisible, closeMenu, referralView }) => {
  return (
    <>
      <TabsMenu
        config={config}
        menuVisible={menuVisible}
        closeMenu={closeMenu}
        referralView={referralView}
      />
    </>
  );
};

const AdminList = ({ logout, config, menuVisible, openMenu, closeMenu }) => {
  const { t } = useTranslation();

  return (
    <>
      <StickyWrapper $isMenuVisible={menuVisible}>
        <List>
          <div>
            {config &&
              config.map((item, key) => (
                <AdminListItem closeMenu={closeMenu} item={item} key={key} />
              ))}{' '}
          </div>
        </List>

        <Col $padding={30} $auto>
          <ANTDButton text={t('Logout')} $wide onClick={logout} />
        </Col>
      </StickyWrapper>

      <StyledMenuOutlined onClick={() => openMenu()} />

      <Drawer open={menuVisible} onClose={closeMenu} placement='left'>
        <Flex vertical justify='space-between' gap={'large'}>
          <List>
            {config &&
              config.map((item, key) => (
                <AdminListItem closeMenu={closeMenu} item={item} key={key} />
              ))}
          </List>

          <Col $padding={24} $auto>
            <ANTDButton text={t('Logout')} $wide onClick={logout} />
          </Col>
        </Flex>
      </Drawer>
    </>
  );
};

const AdminListItem = ({ item, closeMenu }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <div>
      <Li
        onClick={() => {
          navigate(item.href);
          closeMenu();
        }}
        $active={pathname === item.href}
      >
        <Typography.Text>{t(item.title)}</Typography.Text>
      </Li>
      {item.subpages && item.subpages.length > 0 && (
        <Container $paddingTop={8} $paddingLeft={28}>
          {item.subpages.map((subpage, key) => (
            <Li
              onClick={() => {
                navigate(subpage.href);
                closeMenu();
              }}
              $active={pathname === subpage.href}
              $height={32}
              $sub={true}
              key={key}
            >
              <Typography.Text>{t(subpage.title)}</Typography.Text>
            </Li>
          ))}
        </Container>
      )}
    </div>
  );
};

const SideBarContainer = styled.div`
  height: 100%;
  background: #ffffff;
  box-shadow: 2px 0px 3px rgba(0, 0, 0, 0.05);
  position: relative;
  z-index: 109;
`;
const StickyWrapper = styled.div`
  height: 100dvh;
  width: 250px;
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
  padding: 28px 0 20px 0;

  @media (max-width: ${BREAKPOINTS.md}px) {
    display: none;
  }
`;
const List = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  row-gap: 8px;
`;
const Li = styled.div`
  min-height: ${(p) => (p.$height ? `${p.$height}px` : '40px')};
  width: 100%;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: ${(p) => (p.$justifyContent ? p.$justifyContent : 'flex-start')};
  cursor: pointer;
  transition: 0.2s ease-out;

  span {
    font-size: ${(p) => (p.$sub ? '15px' : '16px')};
  }

  ${({ $active }) =>
    $active
      ? `
    span {
      color: #006fff;
    }
  `
      : ``}
  &:hover {
    span {
      color: #006fff;
    }
  }
`;
const StyledMenuOutlined = styled(MenuOutlined)`
  display: none;

  @media (max-width: ${BREAKPOINTS.md}px) {
    display: block;
    cursor: pointer;
    font-size: 20px;
    padding: 24px 18px;
    position: sticky;
    top: 0;
    left: 0;
  }
`;
